// File: src/components/providers/toast-provider.tsx
// Purpose: Toast notification provider for InstaDev
// InstaDev - Toast Provider


import { Toaster } from 'sonner'
import { useThemeStore } from '@/lib/stores/theme-store'

export function ToastProvider() {
  const { effectiveTheme } = useThemeStore()

  return (
    <Toaster
      theme={effectiveTheme}
      position="bottom-right"
      toastOptions={{
        style: {
          background: effectiveTheme === 'dark' ? '#18181b' : '#ffffff',
          color: effectiveTheme === 'dark' ? '#fafafa' : '#09090b',
          border: effectiveTheme === 'dark' ? '1px solid #27272a' : '1px solid #e4e4e7',
        },
      }}
    />
  )
}